import { v4 as uuidv4 } from 'uuid';
import Login from "../components/login/Login";
import Home from "../components/home/Home";
import {HOME, LOGIN} from "../constants/routes";
export const routes = [
    {
        id: uuidv4(),
        path: LOGIN,
        Component: Login
    },
    {
        id: uuidv4(),
        path: HOME,
        Component: Home
    }
]
